import './styles/InputTime.css';

import { Input } from '@chakra-ui/react';
import { useEffect } from 'react';

import {
	defineBorderColorValue,
	defineInputValue,
} from './constants/inputsControl';
import { setInputsWithLocalstorage } from './constants/setInputsWithLocalstorage';
import { IInputs } from './models/InputsModel';

export const InputTime = ({ ...others }: IInputs) => {
	const {
		dataTest,
		column,
		handleOnChange,
		inputValue,
		name,
		setInputValue,
		validation,
		localStorageValue,
	} = others;

	useEffect(() => {
		setInputsWithLocalstorage({
			column,
			localStorageValue,
			name,
			setInputValue,
		});
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, []);

	return (
		<Input
			data-test={dataTest}
			className='input-time'
			type={'time'}
			borderRadius={'10px'}
			borderColor={defineBorderColorValue({
				name,
				validation,
			})}
			focusBorderColor='#e2e8f0'
			h={'3em'}
			fontSize={'12px'}
			name={name}
			onChange={event => handleOnChange(event)}
			value={defineInputValue({
				name,
				inputValue,
			})}
		/>
	);
};
